// extracted by mini-css-extract-plugin
export var label = "_ia-2";
export var slideContainer = "_ia-0";
export var slider = "_ia-1";